// extracted by mini-css-extract-plugin
var _1 = "active-FFVeu";
var _2 = "selected-NdQlE";
var _3 = "tab-UsCYY";
var _4 = "tabs-qlM3d";
export { _1 as "active", _2 as "selected", _3 as "tab", _4 as "tabs" }
